// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"127":"f6a6a894","416":"47f78c64","422":"8f2ceba8"}[chunkId] + ".chunk.js");